var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"patient-view response"},[_c('QuestionnaireCard',{attrs:{"patient":_vm.patient}}),_c('ChecklistCard',{attrs:{"patient":_vm.patient}}),(_vm.getUserType !== 'observer')?_c('AppointmentCard',{attrs:{"patient":_vm.patient}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }